/**
 * Formats a byte count into a human-readable file size string (B / KB / MB).
 * Returns "N/A" for null or undefined.
 */
export function formatFileSize(bytes: number | null | undefined): string {
  if (bytes == null) return "N/A";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(2)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
}
